import { ProductCustomField } from '../ProductCustomField'
import { ProductOptionName } from '../ProductOption'

import PRODUCT_VARIANT_DOMAIN_TYPES from './ProductVariantDomainTypes'
import { PromoConfig } from './PromoConfig'

// @i18n-ignore-start
export const PRODUCT_VARIANT_STATUS = {
  ACTIVE: 'ACTIVE',
  RETIRED: 'RETIRED',
  DEVELOPMENT: 'DEVELOPMENT',
}
// @i18n-ignore-end

export interface ILocalizedColorGrouping {
  value: string
  displayName: string
}

export interface IBaseProductVariant {
  readonly id: number
  readonly options: ProductVariantOption[]
  readonly price: number
  readonly title: string
  readonly shopifyVariantId: number
  readonly shopifyProductId: number
  readonly sku: string
  readonly productId?: number
  readonly customFields?: ProductCustomField[] | undefined
  readonly status: keyof typeof PRODUCT_VARIANT_STATUS
  readonly vendorType?: string
  readonly giftCardCredit?: number
  readonly savings?: string
  readonly colorGrouping?: string | null
  readonly localizedColorGrouping?: ILocalizedColorGrouping | null
  readonly servings?: string
  readonly pricePerServing?: number
  readonly traditionalPricePerServing?: number
  readonly promoConfig?: PromoConfig[] | null
  readonly lastChance?: string | null
}

export default class BaseProductVariant implements IBaseProductVariant {
  readonly id: number
  readonly options: ProductVariantOption[]
  readonly price: number
  readonly title: string
  readonly productVariantDomainTypes: PRODUCT_VARIANT_DOMAIN_TYPES
  readonly shopifyVariantId: number
  readonly shopifyProductId: number
  readonly sku: string
  readonly productId?: number
  readonly customFields?: ProductCustomField[] | undefined
  readonly status: keyof typeof PRODUCT_VARIANT_STATUS
  readonly vendorType?: string
  readonly giftCardCredit?: number
  readonly savings?: string
  readonly colorGrouping?: string | null
  readonly localizedColorGrouping?: ILocalizedColorGrouping | null
  readonly servings?: string
  readonly pricePerServing?: number
  readonly traditionalPricePerServing?: number
  readonly promoConfig?: PromoConfig[] | null
  readonly lastChance?: string | null
  constructor(
    {
      id,
      options,
      price,
      title,
      shopifyVariantId,
      shopifyProductId,
      sku,
      productId,
      customFields = [],
      status,
      vendorType,
      giftCardCredit,
      savings,
      colorGrouping,
      localizedColorGrouping,
      servings,
      pricePerServing,
      traditionalPricePerServing,
      promoConfig = [],
      lastChance,
    }: IBaseProductVariant,
    productVariantDomainTypes: PRODUCT_VARIANT_DOMAIN_TYPES,
  ) {
    this.shopifyVariantId = shopifyVariantId
    this.shopifyProductId = shopifyProductId
    this.sku = sku
    this.productId = productId

    this.id = id
    this.options = options
    this.price = price
    this.title = title
    this.productId = productId
    this.customFields = customFields
    this.status = status
    this.productVariantDomainTypes = productVariantDomainTypes
    this.vendorType = vendorType
    this.giftCardCredit = giftCardCredit
    this.savings = savings
    this.colorGrouping = colorGrouping
    this.localizedColorGrouping = localizedColorGrouping
    this.servings = servings
    this.pricePerServing = pricePerServing
    this.traditionalPricePerServing = traditionalPricePerServing
    this.promoConfig = promoConfig
    this.lastChance = lastChance
    return {
      ...this,
    }
  }
}

export interface IProductVariantOption {
  readonly name: ProductOptionName
  readonly value: string
  readonly displayName?: string
}

export class ProductVariantOption implements IProductVariantOption {
  readonly name: ProductOptionName
  readonly value: string
  readonly displayName?: string

  constructor({ name, value, displayName }: ProductVariantOption) {
    this.name = name
    this.value = value
    this.displayName = displayName
    return {
      ...this,
    }
  }
}
